export default "__VITE_ASSET__3d13619b__"